<template>
  <div class="toolbar">
    <span class="home">
      <div @click="nav('home')" class="title">测评首页</div>
      <!--<div style="text-align: center">新领创教育</div>-->
    </span>
    <span @click="nav('user')" style="cursor:pointer;">您好 {{ $store.state.auth.name ? $store.state.auth.name : ''
      }}，欢迎使用</span> <!--<span style="margin: 0 10px">{{$store.state.auth.mobile?$store.state.auth.mobile:''}}</span>-->
    <div @click="nav('user')" class="user-center">
      <img style="cursor:pointer;" :src="$store.state.auth.avatar" alt="">
      <p>个人中心</p>
    </div>
    <el-link type="danger" @click="logout">退出</el-link>

  </div>
</template>

<script>
import {
  logout

} from "@/api/api.js";

export default {
  methods: {
    nav(val) {
      this.$router.push(`/${val}`)

    },
    logout() {
      let that = this
      logout({token: this.$store.state.auth.token}).then(res => {
        if (res.code == 1) {
          this.$message.success(res.msg)
          this.$store.commit('SET_LOGOUT')
          this.$router.push('/')
        }
      }).catch(function (err) {
        // console.log(error.data)
        that.$message.error(err.data)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  position: sticky;
  top: 0px;
  z-index: 2;
  right: 0;
  padding-right: 5%;
  text-align: right;
  height: 74px;
  line-height: 74px;
  background: #222222;
  color: #fff;
  font-size: 14px;

  .home {
    float: left;
    padding: 0 0.5rem;
    // margin-left: 5rem;
    font-size: 22px;
    
    .title{
      font-family: 'HanYiHei SC';
    }

    div {
      &:first-child {
        line-height: 2.1;
        text-align: center;
        cursor: pointer;

      }

      &:nth-child(2) {
        font-size: 13px;
        line-height: 0.8;
      }
    }
  }
  .user-center {
    display: inline-block;
    line-height: 2;
    vertical-align: middle;
    margin: 0 10px;
    img {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      overflow: hidden;
      vertical-align: middle;
      margin: 0 10px;
    }
    p {
      font-size: 12px;
      text-align: center;
    }
  }

}
</style>